import React from "react";
import {doEllipsisCutoff} from "../../utils/str.utils";

type Props = {
    txt: string;
    max: number | null;
}
export const EllipsisCutoff: React.FC<Props> = ({txt, max}) => {
    const [s, cutoff] = doEllipsisCutoff(txt, max);
    if (cutoff) {
        return <span title={txt}>{s}</span>
    } else {
        return <span>{s}</span>
    }
}
